// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rider_pageWrap__kYNUB {
  padding: 4px 4px 32px;
}

.Rider_desktopTable__Be6I2 {
  display: block;
}

.Rider_mobileList__Kb4uL {
  display: none;
}

@media (max-width: 767px) {
  .Rider_desktopTable__Be6I2 {
    display: none;
  }
  .Rider_mobileList__Kb4uL {
    display: block;
  }
}

/* =========================================================
   Status pills
   ========================================================= */
.Rider_pillBase__uosr2 {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.Rider_pillGreen__DlXPt { background: #E9F9EF; color: #16A34A; }
.Rider_pillRed__U6kxV { background: #FDEDED; color: #DC2626; }
.Rider_pillBlue__LYO4- { background: #EAF2FE; color: #3B82F6; }
.Rider_pillGrey__xp2V\\+ { background: #F3F4F6; color: #6B7280; }
.Rider_pillAmber__iwDgp { background: #FDEEDD; color: #F7941D; }

.Rider_noRider__BNtuO {
  color: #9CA3AF;
  font-style: italic;
}

/* =========================================================
   Toolbar (All Rider Deliveries)
   ========================================================= */
.Rider_toolbarRow__xKwCf {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.Rider_searchInput__yybot {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 240px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.Rider_searchInput__yybot:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.Rider_filterSelect__ZDkdo {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 170px;
  flex-shrink: 0;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.Rider_filterSelect__ZDkdo:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.Rider_clampText__EvR1N {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 260px;
  font-size: 12.5px;
}

.Rider_nameSub__JabJs {
  display: block;
  font-size: 11.5px;
  color: #9CA3AF;
}

.Rider_orderCountLink__\\+\\+tTw {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #4c2fb3;
  font-weight: 700;
  cursor: pointer;
  background: #F5F3FE;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12.5px;
  transition: background 0.15s ease;
}
.Rider_orderCountLink__\\+\\+tTw:hover {
  background: #E7DEFB;
}

.Rider_emptyState__\\+8D55 {
  text-align: center;
  color: #9CA3AF;
  font-size: 13.5px;
  padding: 40px 0;
}

/* =========================================================
   Mobile card list
   ========================================================= */
.Rider_mobileCard__RSP7J {
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 12px;
}

.Rider_mobileRow__DdyNK {
  display: flex;
  gap: 12px;
  padding: 4px 0;
  font-size: 13px;
}

.Rider_mobileLabel__a7o3s {
  min-width: 100px;
  flex-shrink: 0;
  color: #6B7280;
  font-weight: 600;
}

.Rider_mobileValue__e\\+7nU {
  color: #1F2430;
}

.Rider_mobileActionRow__k\\+T53 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

/* =========================================================
   Rider Orders — info bar + table
   ========================================================= */
.Rider_metaRow__Bl8pu {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 16px 24px 0;
}

.Rider_metaChip__1qyJl {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #F5F3FE;
  color: #4c2fb3;
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 20px;
}

.Rider_premiumTable__jLEff {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
}

.Rider_premiumTable__jLEff thead th {
  background: #F5F3FE;
  color: #4c2fb3;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 11.5px;
  font-weight: 700;
  padding: 12px 14px;
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid #E7E9F1;
}

.Rider_premiumTable__jLEff tbody td {
  padding: 10px 14px;
  border-bottom: 1px solid #F1F2F6;
  color: #374151;
  vertical-align: middle;
}

.Rider_premiumTable__jLEff tbody tr:hover td {
  background: #FAF8FF;
}

.Rider_premiumTable__jLEff tbody tr:last-child td {
  border-bottom: none;
}

.Rider_orderLink__bsK18 {
  color: #4c2fb3;
  font-weight: 700;
  text-decoration: none;
}
.Rider_orderLink__bsK18:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/rider/Rider.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,0BAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,wBAAW,mBAAmB,EAAE,cAAc,EAAE;AAChD,yBAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,0BAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,0BAAa,mBAAmB,EAAE,cAAc,EAAE;;AAElD;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.desktopTable {\n  display: block;\n}\n\n.mobileList {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .desktopTable {\n    display: none;\n  }\n  .mobileList {\n    display: block;\n  }\n}\n\n/* =========================================================\n   Status pills\n   ========================================================= */\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.pillGreen { background: #E9F9EF; color: #16A34A; }\n.pillRed { background: #FDEDED; color: #DC2626; }\n.pillBlue { background: #EAF2FE; color: #3B82F6; }\n.pillGrey { background: #F3F4F6; color: #6B7280; }\n.pillAmber { background: #FDEEDD; color: #F7941D; }\n\n.noRider {\n  color: #9CA3AF;\n  font-style: italic;\n}\n\n/* =========================================================\n   Toolbar (All Rider Deliveries)\n   ========================================================= */\n.toolbarRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.searchInput {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 240px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.searchInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.filterSelect {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 170px;\n  flex-shrink: 0;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.filterSelect:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.clampText {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  max-width: 260px;\n  font-size: 12.5px;\n}\n\n.nameSub {\n  display: block;\n  font-size: 11.5px;\n  color: #9CA3AF;\n}\n\n.orderCountLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: #4c2fb3;\n  font-weight: 700;\n  cursor: pointer;\n  background: #F5F3FE;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12.5px;\n  transition: background 0.15s ease;\n}\n.orderCountLink:hover {\n  background: #E7DEFB;\n}\n\n.emptyState {\n  text-align: center;\n  color: #9CA3AF;\n  font-size: 13.5px;\n  padding: 40px 0;\n}\n\n/* =========================================================\n   Mobile card list\n   ========================================================= */\n.mobileCard {\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  background: #ffffff;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.mobileRow {\n  display: flex;\n  gap: 12px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.mobileLabel {\n  min-width: 100px;\n  flex-shrink: 0;\n  color: #6B7280;\n  font-weight: 600;\n}\n\n.mobileValue {\n  color: #1F2430;\n}\n\n.mobileActionRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n/* =========================================================\n   Rider Orders — info bar + table\n   ========================================================= */\n.metaRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 16px 24px 0;\n}\n\n.metaChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 6px 14px;\n  border-radius: 20px;\n}\n\n.premiumTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13px;\n}\n\n.premiumTable thead th {\n  background: #F5F3FE;\n  color: #4c2fb3;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-size: 11.5px;\n  font-weight: 700;\n  padding: 12px 14px;\n  text-align: left;\n  white-space: nowrap;\n  border-bottom: 1px solid #E7E9F1;\n}\n\n.premiumTable tbody td {\n  padding: 10px 14px;\n  border-bottom: 1px solid #F1F2F6;\n  color: #374151;\n  vertical-align: middle;\n}\n\n.premiumTable tbody tr:hover td {\n  background: #FAF8FF;\n}\n\n.premiumTable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.orderLink {\n  color: #4c2fb3;\n  font-weight: 700;\n  text-decoration: none;\n}\n.orderLink:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `Rider_pageWrap__kYNUB`,
	"desktopTable": `Rider_desktopTable__Be6I2`,
	"mobileList": `Rider_mobileList__Kb4uL`,
	"pillBase": `Rider_pillBase__uosr2`,
	"pillGreen": `Rider_pillGreen__DlXPt`,
	"pillRed": `Rider_pillRed__U6kxV`,
	"pillBlue": `Rider_pillBlue__LYO4-`,
	"pillGrey": `Rider_pillGrey__xp2V+`,
	"pillAmber": `Rider_pillAmber__iwDgp`,
	"noRider": `Rider_noRider__BNtuO`,
	"toolbarRow": `Rider_toolbarRow__xKwCf`,
	"searchInput": `Rider_searchInput__yybot`,
	"filterSelect": `Rider_filterSelect__ZDkdo`,
	"clampText": `Rider_clampText__EvR1N`,
	"nameSub": `Rider_nameSub__JabJs`,
	"orderCountLink": `Rider_orderCountLink__++tTw`,
	"emptyState": `Rider_emptyState__+8D55`,
	"mobileCard": `Rider_mobileCard__RSP7J`,
	"mobileRow": `Rider_mobileRow__DdyNK`,
	"mobileLabel": `Rider_mobileLabel__a7o3s`,
	"mobileValue": `Rider_mobileValue__e+7nU`,
	"mobileActionRow": `Rider_mobileActionRow__k+T53`,
	"metaRow": `Rider_metaRow__Bl8pu`,
	"metaChip": `Rider_metaChip__1qyJl`,
	"premiumTable": `Rider_premiumTable__jLEff`,
	"orderLink": `Rider_orderLink__bsK18`
};
export default ___CSS_LOADER_EXPORT___;
